import React, { useEffect, useState } from 'react';
import AUIIcon from '@ancert/aui-icon';
import { useNotification } from '@ancert/aui-notification-context';
import { shape } from 'prop-types';
import renderContent from './renderContent';
import { getFileIcon } from '../../../utils/fileUtils';
import getDownload from '../../../services/download.service';
import getBase64FromUrl from '../../../utils/base64Utils';
import { downloadMp3Base64File } from '../../../utils/downloadUtils';

const DatosComunicacionConsulta = ({ data }) => {
  const { openNotification } = useNotification();
  const [dataParsed, setDataParsed] = useState([]);
  const [dataFile, setDataFile] = useState([]);
  const [isError, setIsError] = useState(false);

  const filterByMP3 = (objects) => objects.filter((obj) => obj.name.endsWith('.mp3'));

  useEffect(() => {
    try {
      setDataParsed(JSON.parse(data.data));
      setDataFile(filterByMP3(data.attachments));
      setIsError(false);
    } catch (e) {
      console.error(e);
      setIsError(true);
    }
  }, [data]);

  const download = async ({ blob, fileName }) => {
    const urlDownLoad = URL.createObjectURL(blob);
    const doc = await getBase64FromUrl(urlDownLoad);
    downloadMp3Base64File({ base64String: doc, fileName });
  };

  const downloadFile = async ({ uuid, name }) => {
    const { status, error, data: result } = await getDownload(uuid);

    if (status !== 200) {
      const { message } = error;
      openNotification({
        title: 'Error',
        content: <div>{message || 'Ha ocurrido un error'}</div>,
        type: 'error',
        centerButtons: true,
      });
    } else {
      download({ blob: result, fileName: name });
    }
  };

  return (
    <div className="c-sii-datos-comunicacion-consulta u-mt-32">
      <h2>Datos de la comunicación</h2>
      {isError || !dataParsed ? (
        <p>No hay datos</p>
      ) : (
        <>
          {dataFile?.length > 0 && (
            <div className="c-sii-datos-comunicacion-consulta__audio">
              {dataFile.length > 0 ? (
                <button
                  type="button"
                  onClick={() => downloadFile(dataFile[0])}
                  className="c-sii-datos-comunicacion-consulta__download"
                >
                  <AUIIcon icon={getFileIcon(dataFile[0].name)} />
                  <p>{dataFile[0].name}</p>
                </button>
              ) : (
                <p>No hay ningún fichero de audio</p>
              )}
            </div>
          )}
          {dataParsed && renderContent(dataParsed)}
        </>
      )}
    </div>
  );
};

DatosComunicacionConsulta.propTypes = {
  data: shape({}),
};
DatosComunicacionConsulta.defaultProps = {
  data: null,
};

export default DatosComunicacionConsulta;
